import React, { useRef, useState } from 'react';
import { GoogleMap, useLoadScript, Marker, StandaloneSearchBox } from '@react-google-maps/api';

const libraries = ['places'];
const mapContainerStyle = {
  width: '100%',
  height: '400px',
};
const defaultCenter = {
  lat: 20.5937, // default latitude (India center)
  lng: 78.9629, // default longitude
};

const MapView = ({ latitude, longitude, onMapClick }) => {
  const [mapRef, setMapRef] = useState(null);
  const [searchBox, setSearchBox] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [searchCenter, setSearchCenter] = useState(null);
  const searchBoxRef = useRef();

  const mapCenter = searchCenter || {
    lat: typeof latitude === 'number' ? latitude : defaultCenter.lat,
    lng: typeof longitude === 'number' ? longitude : defaultCenter.lng,
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const onPlacesChanged = () => {
    const places = searchBox.getPlaces();
    if (places && places.length > 0) {
      const place = places[0];
      const loc = place.geometry.location;
      const newCenter = { lat: loc.lat(), lng: loc.lng() };
      setSearchCenter(newCenter);
      if (onMapClick) {
        onMapClick(newCenter);
      }
      // Zoom to the selected location
      if (mapRef) {
        mapRef.panTo(newCenter);
        mapRef.setZoom(15);
      }
      setSearchValue(place.formatted_address || '');
    }
  };

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading maps...</div>;
  }

  return (
    <div>
      <StandaloneSearchBox
        onLoad={setSearchBox}
        onPlacesChanged={onPlacesChanged}
        ref={searchBoxRef}
      >
        <input
          type="text"
          placeholder="Search location..."
          className="w-full p-2 mb-2 border rounded"
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
          style={{ boxSizing: 'border-box' }}
        />
      </StandaloneSearchBox>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={latitude && longitude ? 14 : 5}
        center={mapCenter}
        onLoad={setMapRef}
        onClick={e => {
          const clickedLocation = {
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
          };
          if (onMapClick) {
            onMapClick(clickedLocation);
          }
          // Zoom to the clicked location
          if (mapRef) {
            mapRef.panTo(clickedLocation);
            mapRef.setZoom(15);
          }
        }}
      >
        {latitude && longitude && (
          <Marker 
            position={{ lat: latitude, lng: longitude }}
            onClick={() => {
              if (mapRef) {
                mapRef.panTo({ lat: latitude, lng: longitude });
                mapRef.setZoom(15);
              }
            }}
          />
        )}
      </GoogleMap>
    </div>
  );
};

export default MapView;
